export const LOGIN_REQUEST_METHOD = "LOGIN_REQUEST_METHOD";
export const LOGIN_SUCCESS_METHOD = "LOGIN_SUCCESS_METHOD";
export const LOGIN_FAILURE_METHOD = "LOGIN_FAILURE_METHOD";
export const LOGOUT_METHOD="LOGOUT_METHOD"
export const REFRESH_TOKEN_METHOD = "REFRESH_TOKEN_METHOD";
export const USER_REQUEST_METHOD = "USER_REQUEST_METHOD";
export const USER_SUCCESS_METHOD = "USER_SUCCESS_METHOD";
export const USER_FAILURE_METHOD = "USER_FAILURE_METHOD";